import type { LearnFAQ } from "@/pages/learn/learnShared";
import {
  makeEsArticle,
  esSaintRelated,
  type EsArticleInput,
} from "./learnFactoryEs";

const reviewBlock = {
  writtenBy: "Neuro Wellness TMS Centers of America",
  reviewedBy: "Daniel Pietras, MD",
  published: "November 3, 2026",
  lastReviewed: "November 3, 2026",
  lastUpdated: "November 3, 2026",
};

const faqs: LearnFAQ[] = [
  {
    question: "¿Con qué rapidez puedo empezar SAINT®?",
    answer:
      "Tras la consulta y la evaluación psiquiátrica, si SAINT® es adecuada, se programa la fMRI y la semana de tratamiento. Muchos pacientes pasan de consulta a tratamiento en cuestión de días.",
  },
];

export const esHowQuicklyStart = makeEsArticle({
  slug: "how-quickly-can-i-start-saint",
  title: "¿Con qué rapidez puedo empezar SAINT®?",
  description:
    "El proceso de SAINT® comienza con una consulta y una evaluación psiquiátrica. Si es adecuada, se programa la fMRI y la semana de tratamiento.",
  h1: "¿Con qué rapidez puedo empezar SAINT®?",
  breadcrumbLabel: "Empezar SAINT®",
  shortAnswer:
    "El proceso de SAINT® comienza con una consulta, que puede hacerse de forma remota. Si SAINT® parece adecuada, se programa una evaluación psiquiátrica y una fMRI, y se planifica la semana de tratamiento. Muchos pacientes pasan de consulta a tratamiento en cuestión de días, aunque los plazos exactos dependen de la programación y de si se requiere autorización previa del seguro. SAINT® suele ser de pago directo; el pago directo puede oscilar entre $25,000 y $28,000.",
  keyTakeaways: [
    "El proceso empieza con una consulta, que puede ser remota.",
    "Luego sigue una evaluación psiquiátrica y una fMRI.",
    "Muchos pacientes empiezan el tratamiento en cuestión de días.",
    "SAINT® suele ser de pago directo.",
    "El pago directo puede oscilar entre $25,000 y $28,000.",
  ],
  sections: [
    {
      heading: "Los pasos para empezar",
      paragraphs: [
        "1. Consulta con el equipo clínico (puede ser remota).",
        "2. Evaluación psiquiátrica para confirmar la elegibilidad.",
        "3. fMRI para personalizar el objetivo de estimulación.",
        "4. Programación de la semana de cinco días de tratamiento.",
      ],
    },
    {
      heading: "Costo y seguro",
      paragraphs: [
        "SAINT® suele ser de pago directo; el pago directo puede oscilar entre $25,000 y $28,000. La TMS convencional suele estar cubierta por los seguros. Verificamos los beneficios de cada paciente sin costo, sea cual sea su aseguradora. La cobertura varía según el plan.",
      ],
    },
  ],
  faqs,
  sources: [],
  relatedLinks: esSaintRelated,
  reviewBlock,
} satisfies EsArticleInput);
